export default function validateNumber(
    value: string | number | undefined,
): number {
    if (value === undefined) {
        return 0
    }

    if (typeof value === 'number') {
        return value
    }

    const numberValue = Number(value.replaceAll(/[^0-9.-]+/g, ''))

    if (Number.isNaN(numberValue)) {
        return 0
    }

    return numberValue
}
